import { Injectable } from "@angular/core";
import { EstadoSolicitudModificada } from "@shared/enums/estadoSolicitudModificada";
import { ModificacionSaldoClienteDTO } from "@shared/models/controlCredito/ModificacionSaldo";
import { DatePipe } from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class UtilCredito {
  constructor(private datePipe: DatePipe) {}

  obtenerDescripcionEstadoModificacion(estado: EstadoSolicitudModificada) {
    if (estado == EstadoSolicitudModificada.Aprobado) {
      return "APROBADO";
    } else if (estado == EstadoSolicitudModificada.Rechazado) {
      return "RECHAZADO";
    } else{
      return "";
    }
  }

  compararSolicitudes(solicitudVieja: ModificacionSaldoClienteDTO, solicitudNueva: ModificacionSaldoClienteDTO){
    const modificaciones: { solicitudViejaDTO: string, solicitudNuevaDTO: string } [] = [];

    if(solicitudVieja.excedido?.monto !== solicitudNueva.excedido?.monto){
      const valorViejo = "Monto excedido: " + (solicitudVieja.excedido?.monto ?? '');
      const valorNuevo = "Monto excedido: " + (solicitudNueva.excedido?.monto ?? 'Sin configuración');
      modificaciones.push({solicitudViejaDTO: valorViejo, solicitudNuevaDTO: valorNuevo});
    }

    if(solicitudVieja.excedido?.fechaDesde !== solicitudNueva.excedido?.fechaDesde){
      const valorViejo = "Fecha desde excedido: " + (this.formatearFecha(solicitudVieja.excedido?.fechaDesde) ?? '');
      const valorNuevo = "Fecha desde excedido: " + (this.formatearFecha(solicitudNueva.excedido?.fechaDesde) ?? 'Sin configuración');
      modificaciones.push({solicitudViejaDTO: valorViejo, solicitudNuevaDTO: valorNuevo});
    }

    if(solicitudVieja.excedido?.fechaHasta !== solicitudNueva.excedido?.fechaHasta){
      const valorViejo = "Fecha hasta excedido: " + (this.formatearFecha(solicitudVieja.excedido?.fechaHasta) ?? '');
      const valorNuevo = "Fecha hasta excedido: " + (this.formatearFecha(solicitudNueva.excedido?.fechaHasta) ?? 'Sin configuración');
      modificaciones.push({solicitudViejaDTO: valorViejo, solicitudNuevaDTO: valorNuevo});
    }

    if(solicitudVieja.vencido?.monto !== solicitudNueva.vencido?.monto){
      const valorViejo = "Monto vencido: " + (solicitudVieja.vencido?.monto ?? '');
      const valorNuevo = "Monto vencido: " + (solicitudNueva.vencido?.monto ?? 'Sin configuración');
      modificaciones.push({solicitudViejaDTO: valorViejo, solicitudNuevaDTO: valorNuevo});
    }

    if(solicitudVieja.vencido?.fechaDesde !== solicitudNueva.vencido?.fechaDesde){
      const valorViejo = "Fecha desde vencido: " + (this.formatearFecha(solicitudVieja.vencido?.fechaDesde) ?? '');
      const valorNuevo = "Fecha desde vencido: " + (this.formatearFecha(solicitudNueva.vencido?.fechaDesde) ?? 'Sin configuración');
      modificaciones.push({solicitudViejaDTO: valorViejo, solicitudNuevaDTO: valorNuevo});
    }

    if(solicitudVieja.vencido?.fechaHasta !== solicitudNueva.vencido?.fechaHasta){
      const valorViejo = "Fecha hasta vencido: " + (this.formatearFecha(solicitudVieja.vencido?.fechaHasta) ?? '');
      const valorNuevo = "Fecha hasta vencido: " + (this.formatearFecha(solicitudNueva.vencido?.fechaHasta) ?? 'Sin configuración');
      modificaciones.push({solicitudViejaDTO: valorViejo, solicitudNuevaDTO: valorNuevo});
    }

    return modificaciones;
  }

  formatearFecha(fechaStr: string | null | undefined): string {
    if (!fechaStr) return null;

    const fecha = new Date(fechaStr);
    return this.datePipe.transform(fecha, 'dd-MM-yyyyTHH:mm:ss') || '';
  }
}
